import React from "react";
import { useTranslation } from "react-i18next";
import { getFaqUrl } from "constants/links";
import StyledButton from "./StyledButton";

export default function FaqButton({
  work,
  lng,
  ButtonComponent = StyledButton,
  sx,
}) {
  const { t } = useTranslation("common");
  const language = lng?.toLowerCase() === "zh-tw" ? "zh-TW" : lng;
  const href = getFaqUrl(work, lng);
  if (!href) return null;

  return (
    <ButtonComponent variant="contained" href={href} sx={sx}>
      {t("button.faq", { lng: language })}
    </ButtonComponent>
  );
}
